/************
 * Developed by : Shiva Software Solutions
 * Date : 02-01-2023
 * Descriptions : Route page for erx upload page
 * Dependicies : To use @material-ui/core,react-router-dom,formik
 ************/
import React from 'react';
import {authRole} from '../../shared/constants/AppConst';

export const ClientDashboardConfig = [
  {
    auth: authRole.user,
    routes: [
      {
        path: '/clientDashboard',
        component: React.lazy(() => import('./appointment')),
      },
    ],
  },
];
